export function shouldUseGamanzaProfileDropdown({ skin, user, gamanzaReady }) {
  return Boolean(
    user?.token &&
    gamanzaReady &&
    skin?.gamanza?.enabled &&
    skin?.gamanza?.mainFrame?.avatar &&
    skin?.gamanza?.mainFrame?.profileDropdown?.enabled
  );
}

export function createGamanzaProfileStatWidgets(uid) {
  return [
    {
      key: 'rank',
      label: 'Rango',
      id: `gamanza-profile-rank-${uid}`,
      gamificationType: 'rank',
      showName: true
    },
    {
      key: 'level',
      label: 'Nivel',
      id: `gamanza-profile-level-${uid}`,
      gamificationType: 'level',
      showName: true
    },
    {
      key: 'tokens',
      label: 'Tokens',
      id: `gamanza-profile-tokens-${uid}`,
      gamificationType: 'token',
      showName: true
    },
    {
      key: 'xp',
      label: 'XP',
      id: `gamanza-profile-xp-${uid}`,
      gamificationType: 'xp',
      progressType: 'rank'
    }
  ];
}

export function getGamanzaProfilePalette(skin) {
  const palette = skin?.gamanza?.lookAndFeel?.palette || {};
  const primary = palette.primary?.main || '#DA4167';
  const normalizedPrimary = primary.replace('#', '');
  const primaryRgb = normalizedPrimary.length === 6
    ? `${parseInt(normalizedPrimary.slice(0, 2), 16)}, ${parseInt(normalizedPrimary.slice(2, 4), 16)}, ${parseInt(normalizedPrimary.slice(4, 6), 16)}`
    : '218, 65, 103';

  return {
    primary,
    primaryRgb,
    secondary: palette.secondary?.main || primary,
    contrastText: palette.primary?.contrastText || palette.text?.primary || '#FFFFFF',
    surface: palette.background?.paper || palette.background?.default || '#040713',
    text: palette.text?.primary || palette.primary?.contrastText || '#FFFFFF'
  };
}

export function mergeGamanzaMenuCategories(categories = [], gamanzaCategories = []) {
  return [...categories, ...gamanzaCategories]
    .filter((category) => category.active && category.category !== 'sportlive' &&
      category.category !== 'tonder' && category.category !== 'espiral_app')
    .sort((firstCategory, secondCategory) => {
      if (firstCategory.category === 'lobby') return -1;
      if (secondCategory.category === 'lobby') return 1;
      return 0;
    });
}

export function shouldShowGamanzaMobileExperience({ skin, user, gamanzaReady, mobileExperience }) {
  return Boolean(
    mobileExperience &&
    user?.token &&
    gamanzaReady &&
    skin?.gamanza?.enabled &&
    skin?.gamanza?.mainFrame?.profileDropdown?.enabled
  );
}
